/* ══ GripForge — GroundLine Snow Shovel PDP ═════════════════════════════════
   Sibling of gf-v6.js (handle), reach.js (wrench) and harness.js (harness).
   Same add-to-cart experience as the handle — pick a kit, tick add-ons, Add to
   cart, the drawer slides in with the gift-unlock bar, an upgrade row and the
   add-ons — built on the rules those pages learned the hard way:

   · PRICES COME FROM LIQUID (window.GF_SNOW). Nothing is priced in this file, so
     an admin price edit can never make the page disagree with checkout.
   · Kits are REAL variants, ONE line of quantity 1. A pack line's quantity is never
     raised: a line quantity of 2 trips Kaching's all-products quantity deal and
     mis-bills the cart (the $220 wrench leak, 2026-08-11).
   · Add to cart POSTs /cart/add.js — that request is what makes Shopify emit
     `product_added_to_cart`, which the Meta pixel listens to. No fbq() here and no
     manual publish: either would double-count.
   · THE DRAWER IS DRAWN FROM THE REAL CART (/cart.js), never from page state.
     Every control writes to the server and redraws from what the server returns.
   · Checkout starts from the drawer's Check out, Shopify's real wallet buttons in the
     drawer, or the buy box's handle-format wallet row (Julian's call, 2026-09-18) —
     which commits the selection with ONE add.js (skipped if it's already in the cart)
     and hands off to Shopify checkout.
   · Nobody pays for what their kit already gives them free: a paid Shipping
     Protection / snow warranty line is removed when the kit in the cart includes it. */
(function(){
"use strict";
var CFG=window.GF_SNOW; if(!CFG) return;
var $=function(s,c){return (c||document).querySelector(s)},
    $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

/* ── money: the shop's own format string, so JS totals read exactly like the
   prices Liquid's | money filter rendered into the page ─────────────────────── */
var FMT=CFG.moneyFormat||'${{amount}}';
function grp(n,sep){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,sep); }
function money(cents){
  cents=Math.max(0,Math.round(+cents||0));
  var whole=Math.floor(cents/100), dec=('0'+(cents%100)).slice(-2), round=Math.round(cents/100);
  return FMT.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
    switch(k){
      case 'amount_no_decimals': return grp(round,',');
      case 'amount_with_comma_separator': return grp(whole,'.')+','+dec;
      case 'amount_no_decimals_with_comma_separator': return grp(round,'.');
      case 'amount_with_apostrophe_separator': return grp(whole,"'")+'.'+dec;
      case 'amount_with_space_separator': return grp(whole,' ')+','+dec;
      default: return grp(whole,',')+'.'+dec;
    }
  });
}
function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){
  return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
var TRASH='<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">'+
 '<path fill="currentColor" d="M9 3h6a1 1 0 0 1 1 1v1h4v2H4V5h4V4a1 1 0 0 1 1-1Zm1 2h4V4h-4v1ZM6 9h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 9Z"/></svg>';

/* ── the kits ──────────────────────────────────────────────────────────────── */
var PACKS=(CFG.packs||[]).filter(function(p){return p && p.id;}), PACK={};
PACKS.forEach(function(p){ PACK[p.id]=p; });
function packQ(q){ for(var i=0;i<PACKS.length;i++) if(PACKS[i].q===q) return PACKS[i]; return null; }
var ADD=CFG.addons||{};
/* an add-on without a real variant id can never be bought — drop it outright */
['ship','wty'].forEach(function(k){ if(ADD[k] && !(ADD[k].id && ADD[k].price)) ADD[k]=null; });
/* every add-on product in the store — a cart holding ONLY these has nothing to protect */
var ADDON_IDS=(CFG.otherAddonIds||[]).filter(Boolean);
['ship','wty'].forEach(function(k){ if(ADD[k]) ADDON_IDS.push(ADD[k].id); });
/* which add-ons each kit gives away — read off the cards, so the copy and the
   behaviour can't drift apart */
var INC={};
$$('#bundles .bnd').forEach(function(b){
  INC[+b.dataset.q]={ship:b.dataset.prot==='1', wty:b.dataset.warr==='1'};
});
function included(k,q){ var c=INC[q]; return !!(c && c[k]); }

var state={tier:packQ(CFG.tier)?CFG.tier:(PACKS[1]||PACKS[0]).q, sel:{ship:false,wty:false}};

/* ══ BUY BOX ═══════════════════════════════════════════════════════════════════ */
function selectTier(q){
  if(!packQ(q)) return;
  state.tier=q;
  $$('#bundles .bnd').forEach(function(b){
    var on=+b.dataset.q===q;
    b.dataset.on=on?'1':'0';
    b.setAttribute('aria-checked',String(on));
  });
  drawAddons(); drawTotals(); syncExpress();
}
$$('#bundles .bnd').forEach(function(b){
  b.addEventListener('click',function(){ selectTier(+b.dataset.q); });
  b.addEventListener('keydown',function(e){
    var k=e.key;
    if(k==='Enter'||k===' '){ e.preventDefault(); selectTier(+b.dataset.q); return; }
    if(k==='ArrowDown'||k==='ArrowRight'||k==='ArrowUp'||k==='ArrowLeft'){
      e.preventDefault();
      var d=(k==='ArrowDown'||k==='ArrowRight')?1:-1,
          n=Math.max(1,Math.min(PACKS.length,state.tier+d));
      selectTier(n);
      var t=$('#bundles .bnd[data-q="'+n+'"]'); if(t) t.focus();
    }
  });
});

/* An add-on the selected kit gives away shows "Included", is ticked and can't be
   bought on top. A paid tick is remembered across kit switches. */
function drawAddons(){
  $$('#addons .addon').forEach(function(a){
    var k=a.dataset.k, inc=included(k,state.tier), on=inc||state.sel[k];
    a.dataset.included=inc?'1':'0';
    a.dataset.on=on?'1':'0';
    a.setAttribute('aria-pressed',String(!!on));
    if(inc) a.setAttribute('aria-disabled','true'); else a.removeAttribute('aria-disabled');
    var c=$('.chk',a); if(c) c.setAttribute('aria-checked',String(!!on));
    var px=$('.a-p',a); if(px && ADD[k]) px.textContent=inc?'Included':'+'+money(ADD[k].price);
  });
}
$$('#addons .addon').forEach(function(a){
  a.addEventListener('click',function(){
    var k=a.dataset.k;
    if(!ADD[k] || included(k,state.tier)) return;
    state.sel[k]=!state.sel[k];
    drawAddons(); drawTotals(); syncExpress();
  });
});
function paidAddons(){
  return ['ship','wty'].filter(function(k){
    return ADD[k] && state.sel[k] && !included(k,state.tier) && $('#addons .addon[data-k="'+k+'"]');
  });
}
/* "Your total" prices the SELECTION — what adding it now costs. */
function selectionTotal(){
  var p=packQ(state.tier), t=p?p.price:0;
  paidAddons().forEach(function(k){ t+=ADD[k].price; });
  return t;
}
function drawTotals(){
  var t=money(selectionTotal());
  ['#tNow','#atcPrice','#sNow'].forEach(function(s){ var e=$(s); if(e) e.textContent=t; });
}
/* The wallet row carries the add-ons with it (it goes through our own cart), so it
   never needs hiding. Kept as a hook so every selection change has one place to go. */
function syncExpress(){}

/* ══ REAL CART ═════════════════════════════════════════════════════════════════ */
var CART=null, busy=false;
function req(url,body){
  var o={credentials:'same-origin',headers:{Accept:'application/json'}};
  if(body){ o.method='POST'; o.headers['Content-Type']='application/json'; o.body=JSON.stringify(body); }
  return fetch(url,o).then(function(r){
    return r.json().catch(function(){ return {}; }).then(function(j){
      if(!r.ok) throw new Error(j.description||j.message||('Request failed ('+r.status+')'));
      return j;
    });
  });
}
function setCart(c){ CART=c; var e=$('#cartCount'); if(e && c) e.textContent=c.item_count; return c; }
function getCart(){ return req('/cart.js').then(setCart); }
function lineFor(p){
  var l={id:p.id, quantity:1};
  /* the free gifts ride on the line itself, so they show in the cart, at checkout,
     on the order and in the confirmation email */
  if(p.includes) l.properties={Includes:p.includes};
  return l;
}
function incOf(i){ return (i.properties && i.properties.Includes) || ''; }
function tierOf(c){
  var q=0; ((c && c.items) || []).forEach(function(i){ var p=PACK[i.variant_id]; if(p && p.q>q) q=p.q; });
  return q;
}

/* After any write: work out what has to change so the cart is exactly one kit
   line of qty 1 (the one just chosen, if any), add-ons at qty 1, and nothing paid
   for that the kit gives away. Returns an /cart/update.js map keyed by LINE KEY
   (keys, not variant ids, because a kit line carries properties), or null. */
function plan(c,keepId){
  var items=(c && c.items)||[], u={}, dirty=false;
  function set(k,q){ u[k]=q; dirty=true; }
  /* which kit line survives: the one just chosen if it is really in the cart (a matching
     "Includes" first), otherwise the highest tier present. Keying off a kit that ISN'T
     in the cart — a failed add — would zero every kit the shopper already had. */
  var keep=null, tier=0;
  if(keepId && PACK[keepId]){
    var want=PACK[keepId].includes||'';
    items.forEach(function(i){ if(!keep && i.variant_id===keepId && incOf(i)===want) keep=i; });
    items.forEach(function(i){ if(!keep && i.variant_id===keepId) keep=i; });
  }
  if(!keep) items.forEach(function(i){ var p=PACK[i.variant_id]; if(p && (!keep || p.q>PACK[keep.variant_id].q)) keep=i; });
  if(keep) tier=PACK[keep.variant_id].q;
  items.forEach(function(i){
    if(!PACK[i.variant_id]) return;
    if(i===keep){ if(i.quantity!==1) set(i.key,1); }   // never a kit line at qty 2 (Kaching)
    else set(i.key,0);                                 // one kit per cart: the new choice replaces the old
  });
  var goods=items.some(function(i){ return ADDON_IDS.indexOf(i.variant_id)<0; });
  items.forEach(function(i){
    if(ADD.ship && i.variant_id===ADD.ship.id){
      /* free with the kit → the paid line goes; nothing left to protect → it goes too */
      if((tier && included('ship',tier)) || !goods) set(i.key,0); else if(i.quantity>1) set(i.key,1);
    }
    if(ADD.wty && i.variant_id===ADD.wty.id){
      /* the snow warranty covers a shovel — with no shovel left it is removed too */
      if(!tier || included('wty',tier)) set(i.key,0); else if(i.quantity>1) set(i.key,1);
    }
  });
  return dirty?u:null;
}
/* After a SUCCESSFUL add: a failed clean-up must not tell the shopper the add failed
   (they'd retry and fire a second add event). Retry once, then fall back to a plain
   redraw — load/open/Check out reconcile again anyway. */
function settleSoft(keepId){
  return settle(keepId).catch(function(){ return settle(keepId); })
    .catch(function(e){ try{ console.warn('[snow cart] settle',e); }catch(_){} return getCart().then(drawDrawer).catch(function(){ drawDrawer(); }); });
}
function settle(keepId,c){
  var got=c ? Promise.resolve(setCart(c)) : getCart();
  return got.then(function(cart){
    var u=plan(cart,keepId);
    return u ? req('/cart/update.js',{updates:u}).then(setCart) : cart;
  }).then(drawDrawer);
}

var DERR='';                                      /* drawer error, rendered by the NEXT drawDrawer() */
function showErr(msg){
  var inDrawer=$('#drawer') && $('#drawer').classList.contains('on');
  if(inDrawer){
    DERR=msg;                                         /* inserting it now would be wiped by the redraw */
  } else {
    var e=$('#atcErr');
    if(e){
      e.textContent=msg; e.hidden=false;
      var r=e.getBoundingClientRect();              /* sticky-bar clicks happen with the buy box off-screen */
      if(r.bottom<0 || r.top>window.innerHeight){ try{ e.scrollIntoView({block:'center',behavior:'smooth'}); }catch(_){ e.scrollIntoView(); } }
    }
  }
}
function hideErr(){ var e=$('#atcErr'); if(e){ e.hidden=true; e.textContent=''; } }

/* A background reconcile (page load / cart open / back from checkout) — never while a
   shopper action is running, and shopper actions wait for it rather than racing it. */
var bg=null;
function reconcile(){
  if(busy) return Promise.resolve();
  if(!bg) bg=settle(null).catch(function(){}).then(function(){ bg=null; });
  return bg;
}
var OOPS="Sorry — that didn't go through. Please try again.";
function fail(msg){ showErr(msg); if($('#drawer') && $('#drawer').classList.contains('on')) drawDrawer(); }
function hasLine(id){ return !!((CART && CART.items)||[]).filter(function(i){ return i.variant_id===id; }).length; }
function withBusy(task,btn,label,keepId,done){
  if(busy) return Promise.resolve();
  busy=true;
  var d=$('#drawer'); if(d) d.setAttribute('aria-busy','true');
  var html=btn?btn.innerHTML:null;               /* innerHTML, not textContent — #atcPrice lives inside #atc */
  if(btn){ btn.disabled=true; if(label) btn.textContent=label; }
  return (bg||Promise.resolve()).then(task).catch(function(err){
    try{ console.warn('[snow cart]',err); }catch(_){}
    /* ⚠ REPAIR, don't just re-read: if add.js merged a kit to qty 2 and the follow-up
       update failed, re-reading would leave it there (Kaching discount, two kits). If the
       repair lands the chosen kit in the cart, the shopper's action DID work — finish it
       normally instead of showing an error for something that succeeded. */
    return settle(keepId||null).then(function(){
      if(keepId && hasLine(keepId)){ if(done) done(); }
      else fail(OOPS);
    },function(){
      return getCart().then(drawDrawer).catch(function(){}).then(function(){ fail(OOPS); });
    });
  }).then(function(){
    busy=false;
    if(d) d.removeAttribute('aria-busy');
    if(btn && btn.isConnected){ btn.disabled=false; btn.innerHTML=html; }
    drawTotals();                                  /* the kit may have changed while the label read "Adding…" */
  });
}

function addToCart(btn){
  var p=packQ(state.tier); if(!p) return;
  var items=[lineFor(p)];
  paidAddons().forEach(function(k){ items.push({id:ADD[k].id, quantity:1}); });
  hideErr();
  withBusy(function(){
    return req('/cart/add.js',{items:items})        /* ← Shopify emits product_added_to_cart from THIS */
      .then(function(){ return settleSoft(p.id); })
      .then(function(){ openCart(btn); });
  }, btn, 'Adding…', p.id, function(){ openCart(btn); });
}
var atc=$('#atc'); if(atc) atc.addEventListener('click',function(){ addToCart(atc); });

/* ── buy-box wallet row: commit the selection, then Shopify checkout ─────────────
   Same job as the handle's goToCheckout(). If the chosen kit (with its ticked paid
   add-ons) is ALREADY in the cart, go straight to checkout — adding it again would
   fire a second add event for one purchase. Otherwise ONE add.js, clean up, go. */
function goToCheckout(btn){
  var p=packQ(state.tier); if(!p) return;
  var want=paidAddons().map(function(k){ return ADD[k].id; }),
      q=(btn && btn.dataset.pay==='shop_pay') ? '?payment=shop_pay' : '',
      go=function(){ location.href='/checkout'+q; };
  var have=((CART && CART.items)||[]),
      hasKit=have.some(function(i){ return i.variant_id===p.id; }),
      hasAdds=want.every(function(id){ return have.some(function(i){ return i.variant_id===id; }); });
  hideErr();
  withBusy(function(){
    if(hasKit && hasAdds) return settle(p.id).then(go);
    var items=[lineFor(p)];
    want.forEach(function(id){ items.push({id:id, quantity:1}); });
    return req('/cart/add.js',{items:items})         /* ← the one add event */
      .then(function(){ return settle(p.id); })        /* must be clean BEFORE paying */
      .then(go);
  }, btn, 'Working…', p.id, go);
}
$$('#dyn [data-wallet], #buyNow, #moreOpts').forEach(function(b){
  b.addEventListener('click',function(){ goToCheckout(b); });
});
var sAtc=$('#stickyAtc'); if(sAtc) sAtc.addEventListener('click',function(){ addToCart(sAtc); });

/* ── drawer ─────────────────────────────────────────────────────────────────── */
function thumb(u,w){ if(!u) return ''; return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||120); }
function drawDrawer(){
  var body=$('#dBody'); if(!body) return;
  var items=(CART && CART.items)||[];
  var rows=items.map(function(i,ix){ return {i:i, pack:PACK[i.variant_id]||null, ix:ix}; })
    .sort(function(a,b){ var ap=a.pack?0:1, bp=b.pack?0:1; return ap!==bp ? ap-bp : a.ix-b.ix; });

  body.innerHTML = rows.length ? rows.map(function(r){
    var i=r.i, subs=[], props=i.properties||{};
    if(i.variant_title && i.variant_title!=='Default Title') subs.push(esc(i.variant_title));
    Object.keys(props).forEach(function(k){
      var v=props[k]; if(k.charAt(0)==='_' || v==null || v==='') return;
      subs.push('<span class="inc">'+(k==='Includes' ? 'Includes '+esc(v) : esc(k)+': '+esc(v))+'</span>');
    });
    var was=i.original_line_price>i.final_line_price ? '<s>'+money(i.original_line_price)+'</s>' : '';
    return '<div class="ci"><img src="'+esc(thumb(i.image,120))+'" alt="">'+
      '<span class="n">'+esc(i.product_title)+subs.map(function(s){ return '<small>'+s+'</small>'; }).join('')+
        /* kit lines and add-ons are delete-only: never a stepper that raises quantity */
        '<span class="qty"><button type="button" class="qty-del" data-key="'+esc(i.key)+'" aria-label="Remove '+esc(i.product_title)+'">'+TRASH+'</button>'+
        '<b>'+i.quantity+'</b></span></span>'+
      '<span class="p">'+money(i.final_line_price)+was+'</span></div>';
  }).join('') : '<p class="ci-empty">Your cart is empty.</p>';
  if(DERR){ body.insertAdjacentHTML('afterbegin','<p class="atc-err" role="alert">'+esc(DERR)+'</p>'); DERR=''; }

  /* gift-unlock bar — the kit tiers, same as the handle's */
  var tier=tierOf(CART), ship=$('#dShip');
  if(ship){
    ship.hidden=!tier;
    var p1=packQ(1), p2=packQ(2), p3=packQ(3), fill=$('#dShipFill'), msg=$('#dShipMsg');
    if(tier && fill) fill.style.width=Math.round(Math.min(tier,3)/3*100)+'%';
    if(tier && msg && p1 && p2 && p3){
      msg.innerHTML =
        tier<=1  ? '<b>'+money(p2.price-p1.price)+'</b> away from a 2nd battery + FREE Shipping Protection'
      : tier===2 ? '✓ FREE Shipping Protection unlocked — <b>'+money(p3.price-p2.price)+'</b> more for a 2nd shovel + FREE Lifetime Warranty'
      :            '🎁 <b>All free gifts unlocked</b> — best value per shovel';
    }
    var t1=$('#dTier1'), t2=$('#dTier2');
    if(t1) t1.classList.toggle('hit',tier>=2);
    if(t2) t2.classList.toggle('hit',tier>=3);
  }

  /* "Add to your order": upgrade the kit (walks the TIERS by swapping the variant,
     like the handle's "Add another handle"), then the add-ons */
  var ups=[], kit=null;
  rows.forEach(function(r){ if(r.pack && (!kit || r.pack.q>kit.pack.q)) kit=r; });
  if(kit && kit.pack.q<3){
    var nx=packQ(kit.pack.q+1);
    if(nx) ups.push('<button class="quickadd" type="button" data-to="'+nx.id+'">'+
      '<img src="'+esc(CFG.thumb||'')+'" alt="">'+
      '<span class="q-t">Upgrade to '+esc(nx.name)+'<small>'+
        (nx.q===2 ? 'Adds a 2nd battery + FREE Shipping Protection' : 'Adds a 2nd shovel + FREE Lifetime Warranty')+
      '</small></span>'+
      '<span class="q-p">+'+money(nx.price-kit.pack.price)+'</span></button>');
  }
  ['ship','wty'].forEach(function(k){
    var a=ADD[k]; if(!a || !items.length) return;  /* nothing to protect in an empty cart */
    if(k==='wty' && !tier) return;                 /* the snow warranty needs a shovel in the cart */
    var free=!!tier && included(k,tier),
        inCart=items.some(function(i){ return i.variant_id===a.id; });
    if(inCart && !free) return;                    /* already bought — its own line shows it */
    ups.push('<button class="addon addon--cart" type="button" data-k="'+k+'"'+(free?' disabled aria-disabled="true"':'')+'>'+
      '<img src="'+esc(a.img)+'" alt="">'+
      '<span class="a-t">'+esc(a.name)+' <small>'+esc(a.sub)+'</small></span>'+
      '<span class="a-p">'+(free?'<b class="a-free">FREE</b>':'+'+money(a.price))+'</span>'+
      '<span class="chk" role="checkbox" aria-checked="'+(free?'true':'false')+'">✓</span></button>');
  });
  var da=$('#dAddons'), du=$('#dUps');
  if(da) da.innerHTML=ups.join('');
  if(du) du.hidden=!ups.length;

  var tot=CART ? CART.total_price : 0,
      orig=CART ? (CART.original_total_price!=null ? CART.original_total_price
                   : items.reduce(function(a,i){ return a+i.original_line_price; },0)) : 0,
      save=Math.max(0,orig-tot);
  var n=$('#dTotal'); if(n) n.textContent=money(tot);
  var sr=$('#dSaveRow'), sv=$('#dSave');
  if(sr) sr.hidden=!(save>0);
  if(sv) sv.textContent='–'+money(save);
  var cnt=CART ? CART.item_count : 0;
  var dc=$('#dCount'); if(dc) dc.textContent='· '+cnt+' item'+(cnt===1?'':'s');
  var ck=$('#dCheckout'); if(ck) ck.disabled=!cnt;
  var wl=$('#dWallets'); if(wl) wl.hidden=!cnt;    /* Shopify's own wallets check out the CART — never an empty one */
  refreshWallets();
}

/* ⚠ Shopify picks which wallets to offer from the cart AT RENDER TIME: rendered with an
   empty cart (every new visitor) it offers only Shop Pay + PayPal, and never adds Google
   Pay / Apple Pay after an add. So re-render just the wallet block from Shopify whenever
   the cart's contents or total change — the same thing Shopify's own cart drawers do. */
var walletsSig=null;
function refreshWallets(){
  var wl=$('#dWallets'); if(!wl || !CART || !CART.item_count) return;
  var sig=CART.item_count+':'+CART.total_price+':'+(CART.items||[]).map(function(i){ return i.key+'x'+i.quantity; }).join(',');
  if(sig===walletsSig) return;
  walletsSig=sig;
  var root=(window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* ⚠ NO `Accept: application/json` here — with that header Shopify renders the section
     WITHOUT the wallet buttons (verified 2026-09-18: 73-byte empty wrapper vs ~12KB). */
  fetch(root+'?sections=gf-snow-wallets',{credentials:'same-origin'})
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(j){
      var h=j && j['gf-snow-wallets']; if(!h || sig!==walletsSig) return;   /* a newer refresh won */
      var t=document.createElement('div'); t.innerHTML=h;
      var inner=t.firstElementChild ? t.firstElementChild.innerHTML : h;  /* drop the shopify-section wrapper */
      if(inner.replace(/\s+/g,'')) wl.innerHTML=inner;
    })
    .catch(function(){ walletsSig=null; });
}

var drawer=$('#drawer'), scrim=$('#scrim');
if(drawer) drawer.addEventListener('click',function(e){
  var t=e.target.closest('button'); if(!t || t.disabled || busy) return;
  if(t.classList.contains('qty-del') && t.dataset.key){
    var key=t.dataset.key,
        gone=((CART && CART.items)||[]).filter(function(i){ return i.key===key; })[0];
    withBusy(function(){
      return req('/cart/change.js',{id:key, quantity:0}).then(function(c){ return settle(null,c); })
        .then(function(){
          /* the buy-box tick means "include with the next Add to cart" — once the shopper
             has thrown that add-on out, the next add must not quietly put it back */
          if(!gone) return;
          ['ship','wty'].forEach(function(k){ if(ADD[k] && gone.variant_id===ADD[k].id) state.sel[k]=false; });
          drawAddons(); drawTotals(); syncExpress();
        });
    });
  } else if(t.dataset.to){
    var p=PACK[+t.dataset.to]; if(!p) return;
    withBusy(function(){
      return req('/cart/add.js',{items:[lineFor(p)]})
        .then(function(){ return settleSoft(p.id); })
        .then(function(){ selectTier(p.q); });     /* keep the buy box in step with the cart */
    }, t, 'Upgrading…', p.id, function(){ selectTier(p.q); });
  } else if(t.dataset.k && t.classList.contains('addon--cart')){
    var a=ADD[t.dataset.k]; if(!a) return;
    withBusy(function(){
      return req('/cart/add.js',{items:[{id:a.id, quantity:1}]}).then(function(){ return settleSoft(null); });
    });
  }
});

/* Scroll-lock ONLY below 980px: above it .gal is position:sticky, and overflow:hidden
   on <body> silently kills sticky (the "gallery went blank on add to cart" bug). */
var LOCK_BELOW=980;
function lockScroll(on){ document.body.style.overflow=(on && window.innerWidth<=LOCK_BELOW)?'hidden':''; }
var lastFocus=null;
function openCart(from){
  if(!drawer) return;
  var was=drawer.classList.contains('on');
  drawer.classList.add('on'); if(scrim) scrim.classList.add('on'); lockScroll(true);
  if(!was){
    lastFocus=from||document.activeElement;
    var x=$('#closeCart'); if(x){ try{ x.focus({preventScroll:true}); }catch(e){ x.focus(); } }
  }
}
function closeCart(){
  if(!drawer || !drawer.classList.contains('on')) return;
  drawer.classList.remove('on'); if(scrim) scrim.classList.remove('on'); lockScroll(false);
  if(lastFocus && lastFocus.isConnected){ try{ lastFocus.focus({preventScroll:true}); }catch(e){} }
  lastFocus=null;
}
addEventListener('resize',function(){ lockScroll(!!(drawer && drawer.classList.contains('on'))); },{passive:true});
var oc=$('#openCart');
if(oc) oc.addEventListener('click',function(){
  drawDrawer(); openCart(oc);
  reconcile();                                     /* the cart may have changed on another page */
});
var cc=$('#closeCart'); if(cc) cc.addEventListener('click',closeCart);
if(scrim) scrim.addEventListener('click',closeCart);
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCart(); });

var dck=$('#dCheckout');
if(dck) dck.addEventListener('click',function(){
  if(!CART || !CART.item_count || busy) return;
  dck.disabled=true; dck.textContent='Loading checkout…';
  /* last reconcile before paying: one kit at qty 1, nothing paid that the kit gives free */
  (bg||Promise.resolve()).then(function(){ return settle(null); }).then(function(){
    if(CART && CART.item_count){ location.href='/checkout'; return; }
    dck.disabled=false; dck.textContent='Check out';
  }).catch(function(){
    if(CART && !plan(CART)){ location.href='/checkout'; return; }   /* cart known clean: go */
    dck.disabled=false; dck.textContent='Check out';
    fail(OOPS);
  });
});
/* coming BACK from checkout restores this page from the back/forward cache — reset
   the button and re-read the cart, which may have changed at checkout */
addEventListener('pageshow',function(e){
  if(!e.persisted) return;
  if(dck){ dck.textContent='Check out'; dck.disabled=false; }
  reconcile();
});

/* ══ GALLERY — one index drives stage, thumbnail trail and dots ════════════════ */
(function(){
  var stage=$('#stage'); if(!stage) return;
  var imgs=$$(':scope > img',stage), gi=0;
  if(imgs.length<2){ ['#gPrev','#gNext','#dots'].forEach(function(s){ var e=$(s); if(e) e.hidden=true; }); }
  function go(i){
    gi=(i+imgs.length)%imgs.length;
    imgs.forEach(function(el,k){ el.classList.toggle('on',k===gi); });
    $$('#trail button').forEach(function(b,k){ b.setAttribute('aria-current',k===gi?'true':'false'); });
    $$('#dots button').forEach(function(b,k){ b.setAttribute('aria-current',k===gi?'true':'false'); });
  }
  var gp=$('#gPrev'), gn=$('#gNext');
  if(gp) gp.addEventListener('click',function(){ go(gi-1); });
  if(gn) gn.addEventListener('click',function(){ go(gi+1); });
  $$('#trail button').forEach(function(b,k){ b.addEventListener('click',function(){ go(k); }); });
  $$('#dots button').forEach(function(b,k){ b.addEventListener('click',function(){ go(k); }); });
  /* ONE pointer handler covers touch, mouse-drag and pen. Keeping touch events
     alongside would fire twice on a phone and skip a slide. */
  var px=null, py=null;
  stage.addEventListener('pointerdown',function(e){
    if(e.target.closest('button')) return;          /* arrows/dots handle their own taps */
    px=e.clientX; py=e.clientY;
  },{passive:true});
  stage.addEventListener('pointerup',function(e){
    if(px===null) return;
    var dx=e.clientX-px, dy=e.clientY-py; px=null;
    if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) go(gi+(dx<0?1:-1));
  });
  stage.addEventListener('pointercancel',function(){ px=null; });
})();

/* ══ DEMO VIDEOS — visuals only; nothing downloads until one is near the screen ═ */
(function(){
  var V=$$('video[data-src]'); if(!V.length) return;
  function start(v){
    if(!v.getAttribute('src')) v.src=v.dataset.src;
    v.muted=true;
    var pr=v.play(); if(pr && pr.catch) pr.catch(function(){});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting) start(e.target);
        else if(e.target.getAttribute('src')) e.target.pause();
      });
    },{rootMargin:'200px 0px'});
    V.forEach(function(v){ io.observe(v); });
  } else V.forEach(start);
})();

/* ══ FAQ — theme accordion: answers are max-height:0 in gf-v6.css and only open
   when their height is set here. Toggling a flag alone never shows an answer. ══ */
$$('#faqList .q').forEach(function(q){
  var btn=$('.q__b',q), pane=$('.q__p',q); if(!btn || !pane) return;
  btn.addEventListener('click',function(){
    var open=q.dataset.open==='1';
    $$('#faqList .q').forEach(function(o){
      o.dataset.open='0';
      var p=$('.q__p',o); if(p) p.style.maxHeight=null;
      var b=$('.q__b',o); if(b) b.setAttribute('aria-expanded','false');
    });
    if(!open){ q.dataset.open='1'; pane.style.maxHeight=pane.scrollHeight+'px'; btn.setAttribute('aria-expanded','true'); }
  });
});

/* ══ reveal-on-scroll, same as the handle ═══════════════════════════════════════ */
(function(){
  var rv=$$('.rv');
  if(!('IntersectionObserver' in window)){ rv.forEach(function(el){ el.classList.add('in'); }); return; }
  var rio=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); rio.unobserve(e.target); } });
  },{threshold:.1, rootMargin:'0px 0px -40px'});
  rv.forEach(function(el){ rio.observe(el); });
  setTimeout(function(){ rv.forEach(function(el){ el.classList.add('in'); }); },2500);
})();

/* ══ sticky bar shows once the buy box is off screen ═══════════════════════════ */
(function(){
  var sticky=$('#sticky'), buy=$('.buy');
  if(!sticky || !buy || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){
    sticky.classList.toggle('on',!es[0].isIntersecting && window.scrollY>600);
  },{threshold:0}).observe(buy);
})();

/* ── boot ──────────────────────────────────────────────────────────────────── */
selectTier(state.tier);
/* a returning shopper's buy box shows the kit already in their cart — otherwise the
   default (Driveway) would be selected, and a wallet tap would swap their kit for it.
   An ad link with ?variant= still wins: that is an explicit choice. */
reconcile().then(function(){
  var t=tierOf(CART);
  if(t && t!==state.tier && !/[?&]variant=/.test(location.search)) selectTier(t);
});
})();
